import { FileCheck, ShieldCheck } from "lucide-react";
import { defineModuleUi } from "@vixio/data";
import { lazyPage } from "@vixio/ui";
import "./api";
import { DocumentsPage } from "./DocumentsPage";

export * from "./api";
export { VerifyForm, VerifyResultView } from "./Verify";
export { IssueDialog } from "./DocumentsPage";
export { DocumentPdfActions } from "./PdfActions";

// Telas carregadas sob demanda: cada uma vira um arquivo à parte no build.
const DocumentPage = lazyPage(() => import("./DocumentPage"), "DocumentPage");
const VerifyPage = lazyPage(() => import("./VerifyPage"), "VerifyPage");

export default defineModuleUi({
  key: "docs",
  title: "Documentos emitidos",
  domain: "documents",
  icon: FileCheck,
  menu: [
    { path: "/documentos/emitidos", label: "Emitidos", minRole: "member", icon: FileCheck, order: 10, keywords: "código hash sha-256 revogação substituição" },
    { path: "/documentos/verificar", label: "Verificar documento", minRole: "member", icon: ShieldCheck, order: 15, keywords: "validar código autenticidade" },
  ],
  routes: [
    { path: "/documentos/emitidos", element: <DocumentsPage />, minRole: "member" },
    { path: "/documentos/emitidos/:id", element: <DocumentPage />, minRole: "member" },
    { path: "/documentos/verificar", element: <VerifyPage />, minRole: "member" },
  ],
});
